import React from 'react';

const LABELS = ['Template', 'Features', 'Competitors', 'Rate', 'Results'];

/**
 * Horizontal step progress indicator for the checklist wizard.
 * @param {{ current: number }} props  `current` is 1-based step number
 */
export function StepBar({ current }) {
  return (
    <div className="flex items-center mb-10" data-testid="step-bar">
      {LABELS.map((label, i) => {
        const idx = i + 1;
        const done   = idx < current;
        const active = idx === current;
        return (
          <React.Fragment key={idx}>
            <div className="flex flex-col items-center flex-shrink-0">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all
                ${done   ? 'bg-emerald-600 text-white'
                : active ? 'bg-emerald-500 text-white ring-2 ring-emerald-300 ring-offset-2 ring-offset-slate-900'
                         : 'bg-slate-700 text-slate-500'}`}>
                {done ? '✓' : idx}
              </div>
              <span className={`text-xs mt-1.5 font-medium hidden sm:block
                ${active ? 'text-emerald-400' : done ? 'text-slate-500' : 'text-slate-600'}`}>
                {label}
              </span>
            </div>
            {i < LABELS.length - 1 && (
              <div className={`flex-1 h-0.5 mx-2 ${done ? 'bg-emerald-600' : 'bg-slate-700'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
